import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginPageComponent } from './login-page.component';
import { LoginService } from './login.service';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [LoginPageComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  entryComponents: [LoginPageComponent],
  providers: [LoginService]
})
export class LoginPageModule { }
